import * as React from 'react';
import { JSONSchema6 } from 'json-schema';

type Props = {
    json: JSONSchema6;
    onChange: (json: JSONSchema6) => void;
}

type State = {
    code: string;
}

export default class JsonEditor extends React.PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            code: JSON.stringify(props.json, null, 2),
        }

        this.setCode = this.setCode.bind(this);
    }

    public componentWillReceiveProps(nextProps: Props) {
        const oldJson = JSON.stringify(this.props.json, null, 2);
        const newJson = JSON.stringify(nextProps.json, null, 2);
        if (oldJson !== newJson) {
            this.setState({ code: newJson });
        }
    }

    public render() {
        return <textarea
            rows={30}
            className="form-control"
            value={this.state.code}
            onChange={(e) => this.onChange(e.target.value)}
            onBlur={this.setCode}
        />;
    }

    private onChange(code: string) {
        this.setState({ code });
    }

    private setCode() {
        try {
            this.props.onChange(JSON.parse(this.state.code));
        } catch (err) {
            alert(err);
        }
    }
}
